import React, { useState } from "react";
import { rolePrivileges, privilegePages, privilegeRoles } from "../constants/definedRoutes/definedRoutes";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";

export function RolePrivileges(props) {
	const [showPrivileges, setShowPrivileges] = useState(false);
	const toggleShowPrivileges = () => setShowPrivileges(!showPrivileges);

	// Function to check if a role has access to a specific page
	const hasAccess = (role, page) => {
		const roleAccess = rolePrivileges[role.key];
		if (!roleAccess) return false;
		return roleAccess[page.key] || false;
	};

	// Checkmark icon component
	const CheckIcon = () => (
		<svg xmlns="http://www.w3.org/2000/svg" height="18px" width="18px" viewBox="0 -960 960 960" fill="#56b202">
			<path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
		</svg>
	);

	// X mark icon component
	const XIcon = () => (
		<svg fill="#d33a18" xmlns="http://www.w3.org/2000/svg" height="18px" width="18px" viewBox="0 -960 960 960">
			<path d="M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z" />
		</svg>
	);

	return <>
		<div className="rbac-wrap pb-1">
			<button type="button" data-testid="role-privilege-toggle" className="btn p-0" onClick={toggleShowPrivileges}>
				<div className="hint-block text-muted na-help-text d-flex align-items-center gap-1">
					<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-info-circle-fill me-1 mt-1" viewBox="0 0 16 16">
						<path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
					</svg>
				</div>
			</button>
			<ToastContainer containerPosition="middle-center" className={`role-privileges-popup ${props.containerClass || ""}`}>
				<Toast show={showPrivileges} bg="light" onClose={toggleShowPrivileges} className="role-privilege-section">
					<Toast.Header>
						<strong className="me-auto">Role-Based Access Privileges</strong>
					</Toast.Header>

					<Toast.Body className="rbac-toast-body">
						<div className="role-privilege-section-body table-responsive">
							<table className="table table-sm table-bordered mb-0 role-privilege-table">
								<thead className="table-light">
									<tr key="header-key-tr" className="table-row">
										<th key="role" className="text-start role-privilege-section-row border-1">Role</th>
										{privilegePages.map((page) => (
											<th key={page.key} className="text-center role-privilege-section-col border-1">{page.label}</th>
										))}
									</tr>
								</thead>

								<tbody>
									{privilegeRoles.map((role, index) => <>
										<tr key={`${role.key}-${index}`} className="table-row">
											<td className="text-start fw-medium text-nowrap role-privilege-section-sticy-col border-1">{role.label}</td>
											{privilegePages.map((page) => {
												let accessCheck = hasAccess(role, page);
												return <td key={`${role.key}-${page.key}`} className={`text-center border-1 ${accessCheck ? '' : 'bg-grey'}`}>
													{accessCheck ? <CheckIcon /> : <XIcon />}
												</td>
											})}
										</tr>
									</>)}
								</tbody>
							</table>
						</div>
					</Toast.Body>
				</Toast>
			</ToastContainer>
		</div>
	</>;
}
